import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import NotificationList from 'flarum/forum/components/NotificationList';
import Link from 'flarum/common/components/Link';
import Discussion from 'flarum/common/models/Discussion';

/**
 * Related discussion for a notification (matches core `NotificationList` grouping logic).
 *
 * @param {import('flarum/common/models/Notification').default} notification
 * @returns {import('flarum/common/models/Discussion').default | null}
 */
function discussionForNotification(notification) {
  const subject = notification.subject();
  if (typeof subject === 'undefined') return null;
  if (subject instanceof Discussion) return subject;
  if (subject && typeof subject.discussion === 'function') return subject.discussion();
  return null;
}

/**
 * Comparable created time for sorting (newest first).
 *
 * @param {import('flarum/common/models/Notification').default} notification
 */
function notificationTimeMs(notification) {
  const d = notification.createdAt();
  if (d instanceof Date) return d.getTime();
  if (d === null || typeof d === 'undefined') return 0;
  return new Date(d).getTime();
}

app.initializers.add('kellari-chronological-notifications', () => {
  override(NotificationList.prototype, 'content', function (original, state) {
    if (state.isLoading() || !state.hasItems()) {
      return original(state);
    }

    const m = typeof window !== 'undefined' && window.m;
    if (!m) return original(state);

    return state.getPages().map((page) => {
      const notifications = page.items
        .filter((notification) => typeof notification.subject() !== 'undefined')
        .slice()
        .sort((a, b) => notificationTimeMs(b) - notificationTimeMs(a));

      const items = [];

      for (let i = 0; i < notifications.length; i++) {
        const notification = notifications[i];
        const C = app.notificationComponents[notification.contentType()];
        if (!C) continue;

        const discussion = discussionForNotification(notification);
        const threadHead = discussion
          ? Link.component(
              {
                href: app.route.discussion(discussion),
                className: 'kellari-notification-thread',
              },
              m('span', { className: 'kellari-notification-thread-title' }, discussion.title())
            )
          : null;

        const rowChildren = threadHead
          ? [m('div', { className: 'kellari-notification-thread-head' }, threadHead), C.component({ notification })]
          : [C.component({ notification })];

        items.push(m('li', { key: notification.id() }, m('div', { className: 'kellari-notification-item' }, rowChildren)));
      }

      return m(
        'div',
        { key: page.number, className: 'NotificationGroup kellari-notification-chronological' },
        m('ul', { className: 'NotificationGroup-content' }, items)
      );
    });
  });
});
